jQuery(document).ready(function ($) {
  // FAQ accordion
  document.querySelectorAll('.eet-seo_accordion-item__heading').forEach(function (div) {
    div.addEventListener('click', function () {
      let targetID = this.getAttribute('data-target');
      let targetElement = $('#' + targetID);
      targetElement.toggleClass("collapsed");
      if (targetElement.hasClass('collapsed')) {
        targetElement.children('.eet-seo_accordion-item__text').slideUp();
      } else {
        targetElement.children('.eet-seo_accordion-item__text').slideDown();
      }
    });
  });

  setTimeout(() => {
    $('.eet-seo_accordion-item').addClass('collapsed');
    $('.eet-seo_accordion-item').children('.eet-seo_accordion-item__text').slideUp();
  }, 2000);
});
